import * as Component from "@adeccoux/tag-ds";
import ThumbDownIcon from "@mui/icons-material/ThumbDownAltOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUpAltOutlined";
import React, { useEffect, useRef, useState } from "react";
import { Navigate, useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { postAnswerFM, saveResulltFM } from "../../util/resources";
import "./question.scss";
import RechargeBar from "./RechargeBar";
const Question = ({
    isExample,
    threshold,
    currQuestNo,
    totalQuest,
    totalBatch,
    currentBatch,
    batchFinishes,
    meterRefills,
    dataQuestion,
    redirectTo,
    moveNextQuest,
    showcounter,
    setOffline,
    userFeedback,
    setUserFeedback,
    isComplete,
    setComplete,
    afterMeterReset,
    finished,
}) => {
    const [isThumbUpClicked, setIsThumbUpClicked] = useState(null);
    const [isThumbDownClicked, setIsThumbDownClicked] = useState(null);
    const correctExamples = useRef(0);

    const [progressVal, setProgressVal] = useState(0);
    const [resetClicked, setResetClicked] = useState(false);
    const [userPerformance, setUserPerformance] = useState({
        correctTargetMatched: 0,
        totalTarget: totalQuest,
        correctMeterReset: 0,
        totalMeterRefils: [],
    });
    let location = useLocation();
    const testPhrases = location.state.user.siteConfig.phrases;

    userPerformance.totalMeterRefils = meterRefills;
    const timerRef = useRef();
    const secLeft = useRef(null);
    const firstNotif = useRef({
        questionNotifCount: 0,
    });
    const elemFocusRef = useRef();
    const spaceKeyRef = useRef(0);
    const [payload, setPayload] = useState({
        duration: 0,
        fwdtimes: 0,
        instrumentType: 1,
        pause: false,
        playTimes: 0,
        questions: [],
        rwdTimes: 0,
        currentMeter: 0,
        currentMeterVal: 0.0,
    });
    payload.questions[0] = dataQuestion;
    let sessionId = window.sessionStorage.getItem("sessionId");
    let testId = window.sessionStorage.getItem("testId");
    const [isClicked, setClicked] = useState(true);
    let timer = dataQuestion?.fnm_time_limit;
    const navigate = useNavigate();

    const [userAnswer, setUserAnswer] = useState({
        answers: [],
        structure: null,
        value: "timeout",
    });

    const handleTimer = () => {
        setProgressVal((prev) => {
            if (timer - prev - 1 >= 0) {
                secLeft.current.children[0].children[0].setAttribute(
                    "data-secLeft",
                    `${timer - prev - 1}s`
                );
            } else {
                prev = timer - 1;
            }

            if (prev == timer - 1) {
                clearInterval(timerRef.current);
                setClicked(false);
                setIsThumbDownClicked(null);
                setIsThumbUpClicked(null);
            }
            return prev + 1;
        });
    };

    useEffect(() => {
        if (secLeft.current && !afterMeterReset.current && !userFeedback.show) {
            secLeft.current.children[0].children[0].setAttribute(
                "data-secLeft",
                `${timer}s`
            );
        }
        elemFocusRef.current?.focus({
            preventScroll: true,
        });
        if (!showcounter && !batchFinishes && !userFeedback.show) {
            if (afterMeterReset.current) {
                timerRef.current = setInterval(handleTimer, 1000);
                afterMeterReset.current = false;
            } else {
                setClicked(false);
                setIsThumbDownClicked(null);
                setIsThumbUpClicked(null);
                setProgressVal(0);
                timerRef.current = setInterval(handleTimer, 1000);
            }
        }
    }, [batchFinishes, showcounter, dataQuestion, userFeedback.show]);

    function handleAnswerPost(payload, testId, sessionId) {
        if (currQuestNo.current == totalQuest - 1) {
            saveResulltFM(testId, sessionId, payload)
                .then((response) => {
                    if (response.status == 200) {
                        setComplete(true);
                    }
                    setTimeout(() => {
                        navigate('/');
                    }, 5000);
                })
                .catch((err) => {
                    console.warn("error", err);
                    setComplete(true);
                    setClicked(true);
                });
        } else {
            moveNextQuest();
            postAnswerFM(testId, sessionId, payload).then((response) => {
                if (response.status == 200) {
                    console.log("AnswerSaved ");
                }
            });
        }
    }

    const saveAndMoveNext = () => {
        payload.questions[0].userAnswer = userAnswer;
        setUserAnswer((prev) => ({ ...prev, value: "timeout" }));
        if (!isExample) {
            handleAnswerPost(payload, testId, sessionId);
        }
    };

    const saveUserAnswer = (answerSelected) => {
        setUserAnswer((prev) => ({ ...prev, value: answerSelected }));
        setClicked(true);
    };

    const detectKeyDown = (e) => {
        if (!showcounter && !userFeedback.show && !batchFinishes) {
            if (e.repeat) {
                return;
            }
            if (e.code === "KeyQ" && !isClicked) {
                setIsThumbUpClicked(true);
                setIsThumbDownClicked(false);
                isExample ? saveUserAnswer("Q") : saveUserAnswer("Q");
            }
            if (e.code === "KeyP" && !isClicked) {
                setIsThumbDownClicked(true);
                setIsThumbUpClicked(false);
                isExample ? saveUserAnswer("P") : saveUserAnswer("P");
            }
            if (e.code === "Space" && !resetClicked) {
                spaceKeyRef.current += 1;
            }
        }
    };

    useEffect(() => {
        if (progressVal === timer) {
            if (dataQuestion.feedback) {
                handleNotification();
                if (currQuestNo.current < totalQuest - 1) {
                    moveNextQuest();
                }
            } else {
                saveAndMoveNext();
            }
        }
    }, [progressVal]);

    const setUserFeedbackMsg = (
        shouldUpdateQuesPopup,
        shouldUpdateMeterPopup,
        notifType,
        fromQuestion,
        headerMsg,
        bodyMsg
    ) => {
        if (fromQuestion) {
            if (shouldUpdateQuesPopup) {
                setUserFeedback({
                    show: true,
                    notiftype: notifType,
                    header: headerMsg,
                    body: bodyMsg,
                    shouldMoveToNextQuestion: true,
                    meterReset: false,
                });
                firstNotif.current.questionNotifCount++;
            } else {
                if (currQuestNo.current === totalQuest - 1) {
                    handleLastQuestionAttempt();
                }
            }
        } else if (shouldUpdateMeterPopup) {
            setUserFeedback({
                show: true,
                notiftype: notifType,
                header: headerMsg,
                body: bodyMsg,
                shouldMoveToNextQuestion: false,
                meterReset: true,
            });
            firstNotif.current.rechargeMeterNotifCount++;
        }
    };
    const handleNotification = () => {
        let selectedAnswer = userAnswer.value;
        if (selectedAnswer === "") {
            selectedAnswer = "timeout";
        }
        setUserAnswer((prev) => ({ ...prev, value: "timeout" }));
        const shouldUpdateQuesPopup =
            firstNotif.current.questionNotifCount === 0 &&
            dataQuestion.feedback;
        const shouldUpdateMeterPopup =
            firstNotif.current.rechargeMeterNotifCount === 0 &&
            dataQuestion.feedback;
        if (dataQuestion.correctAnswer === selectedAnswer) {
            correctExamples.current = userPerformance.correctTargetMatched + 1;
            setUserPerformance((prev) => {
                const newVal = {
                    ...prev,
                    correctTargetMatched: prev.correctTargetMatched + 1,
                };
                return newVal;
            });
            setUserFeedbackMsg(
                shouldUpdateQuesPopup,
                shouldUpdateMeterPopup,
                1,
                true,
                testPhrases["20023619"],
                testPhrases["20023620"]
            );
        } else if (selectedAnswer === "timeout") {
            const phrase = testPhrases["20023607"].split(". ");
            setUserFeedbackMsg(
                shouldUpdateQuesPopup,
                shouldUpdateMeterPopup,
                3,
                true,
                phrase[0] + ".",
                phrase[1]
            );
        } else if (selectedAnswer === "perfectRecharge") {
            setUserPerformance((prev) => ({
                ...prev,
                correctMeterReset: prev.correctMeterReset + 1,
            }));
            setUserFeedbackMsg(
                shouldUpdateQuesPopup,
                shouldUpdateMeterPopup,
                1,
                false,
                testPhrases["20023613"],
                testPhrases["20023614"]
            );
        } else if (selectedAnswer === "earlyRecharge") {
            setUserFeedbackMsg(
                shouldUpdateQuesPopup,
                shouldUpdateMeterPopup,
                2,
                false,
                testPhrases["20023615"],
                testPhrases["20023616"]
            );
        } else if (selectedAnswer === "noRecharge") {
            setUserFeedbackMsg(
                shouldUpdateQuesPopup,
                shouldUpdateMeterPopup,
                3,
                false,
                testPhrases["20023617"],
                testPhrases["20023618"]
            );
        } else {
            setUserFeedbackMsg(
                shouldUpdateQuesPopup,
                shouldUpdateMeterPopup,
                2,
                true,
                testPhrases["20023606"],
                testPhrases["20023620"]
            );
        }
    };

    const handleLastQuestionAttempt = () => {
        var ExampleComplPhrase = testPhrases["20023611"]
            .replace("<X>", correctExamples.current)
            .replace("<Y>", userPerformance.totalTarget)
            .replace("<A>", userPerformance.correctMeterReset)
            .replace("<B>", userPerformance.totalMeterRefils.length);
        setClicked(true);
        setUserFeedback({
            show: true,
            notiftype: 1,
            header: testPhrases["20023608"],
            body: ExampleComplPhrase,
            shouldMoveToNextQuestion: true,
        });
    };

    useEffect(() => {
        if (
            (userFeedback.show || batchFinishes || isComplete) &&
            !afterMeterReset.current
        ) {
            clearInterval(timerRef.current);
        } else if (
            !batchFinishes &&
            !showcounter &&
            !userFeedback.show &&
            progressVal < timer - 1 &&
            !afterMeterReset.current
        ) {
            clearInterval(timerRef.current);
            setClicked(false);
            setIsThumbDownClicked(null);
            setIsThumbUpClicked(null);
            timerRef.current = setInterval(handleTimer, 1000);
        } else if (afterMeterReset.current) {
            afterMeterReset.current = false;
        }
    }, [batchFinishes, isComplete, userFeedback.show]);

    useEffect(() => {
        function changeStatus() {
            if (!navigator.onLine) {
                setOffline(true);
                setUserFeedback({
                    show: true,
                });
            }
        }
        window.addEventListener("online", changeStatus);
        window.addEventListener("offline", changeStatus);
        return () => {
            window.removeEventListener("online", changeStatus);
            window.removeEventListener("offline", changeStatus);
        };
    }, []);

    if (isExample && !dataQuestion && !userFeedback.show) {
        var backFromExample = true;
        localStorage.removeItem("firstLoadDone");
        return <Navigate to={redirectTo} state={{ ...location.state, samplesCompleted: true, warmUp: false }}></Navigate>;
    }
    let data = "";
    if (dataQuestion) {
        data = dataQuestion.questionText.split("|");
    } else {
        dataQuestion = {
            questionImage: "",
            target: "",
        };
    }
    let inputSize = data.length;

    let rowsCount = inputSize / 3;
    let multiArray = [];
    let index = 0,
        columnsCount = 3;

    for (var i = 0; i < rowsCount; i++) {
        var temp = [];
        if (i === rowsCount - 1) {
            if (Math.floor(inputSize / 3) * 3 !== inputSize) {
                columnsCount = inputSize - Math.floor(inputSize / 3) * 3;
            }
        }

        for (var j = 0; j < columnsCount; j++) {
            temp.push(data[index]);
            index++;
        }
        multiArray[i] = temp;
    }
    const handleMeterValues = (currentValue, currentNumber) => {
        payload.currentMeter = currentNumber;
        payload.currentMeterVal = currentValue;
    };

    return (
        <>
            <div
                className="wrapper"
                ref={elemFocusRef}
                tabIndex="-1"
                onKeyDown={detectKeyDown}
                onBlur={(e) =>
                    e.target.focus({
                        preventScroll: true,
                    })
                }
                style={{ outline: "none", filter: showcounter || userFeedback.show || isComplete || batchFinishes ? "blur(8px)" : "" }}
            >
                <div className="top-progress-container" ref={secLeft}>
                    <Component.ProgressBar
                        circular
                        step={progressVal}
                        steps={timer}
                    />
                </div>
            </div>
            <div className="question-container" style={{ filter: showcounter || userFeedback.show || isComplete || batchFinishes ? "blur(8px)" : "" }}>
                <div className="value-table">
                    <Component.Table>
                        <Component.THead>
                            {multiArray.map((items, index) => {
                                return (
                                    <Component.TRow key={index}>
                                        {items.map((subItems, sIndex) => {
                                            return (
                                                <Component.TElement>
                                                    {subItems}
                                                </Component.TElement>
                                            );
                                        })}
                                    </Component.TRow>
                                );
                            })}
                        </Component.THead>
                    </Component.Table>
                </div>
                <div className="mid-section">
                    <div className="question-main-value">
                        <img
                            alt="avatar image"
                            className="back-image"
                            src={`/${dataQuestion.questionImage}`}
                        />
                        <p
                            className={`centered ${dataQuestion.questionImage.split("/")[2]
                                }`}
                        >
                            {dataQuestion.target}
                        </p>
                    </div>
                    <div
                        className={
                            !isClicked
                                ? "inlineDivs enabled-button"
                                : "inlineDivs"
                        }
                    >
                        <div className=" match-button-container">
                            <button
                                aria-label={testPhrases["20023609"]}
                                className={`match-button ${isThumbUpClicked == null
                                        ? ""
                                        : isThumbUpClicked
                                            ? "selected-button"
                                            : "unselected-button"
                                    }`}
                                onClick={() => {
                                    setIsThumbUpClicked(true);
                                    setIsThumbDownClicked(false);
                                    isExample
                                        ? saveUserAnswer("Q")
                                        : saveUserAnswer("Q");
                                }}
                                disabled={isClicked}
                            >
                                <ThumbUpIcon />
                            </button>
                            <div className="test-phrase">
                                {testPhrases["20023609"]}
                            </div>
                        </div>
                        <div className="match-button-container">
                            <button
                                aria-label={testPhrases["20023610"]}
                                className={`match-button ${isThumbDownClicked == null
                                        ? ""
                                        : isThumbDownClicked
                                            ? "selected-button"
                                            : "unselected-button"
                                    }`}
                                onClick={() => {
                                    setIsThumbDownClicked(true);
                                    setIsThumbUpClicked(false);
                                    isExample
                                        ? saveUserAnswer("P")
                                        : saveUserAnswer("P");
                                }}
                                disabled={isClicked}
                            >
                                <ThumbDownIcon />
                            </button>
                            <div className="test-phrase">
                                {testPhrases["20023610"]}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="recharge-bar-page-container">
                    <RechargeBar
                        counterScreen={showcounter}
                        thresholdTimer={threshold}
                        userFeedback={userFeedback}
                        breather={batchFinishes}
                        handleNotification={handleNotification}
                        userPerformance={userPerformance}
                        spaceKeyRef={spaceKeyRef}
                        completedTest={isComplete}
                        setUserFeedbackMsg={setUserFeedbackMsg}
                        setUserPerformance={setUserPerformance}
                        testPhrases={testPhrases}
                        dataQuestion={dataQuestion}
                        setResetClicked={setResetClicked}
                        resetClicked={resetClicked}
                        handleMeterValues={handleMeterValues}
                        isExample={isExample}
                    />
                </div>
            </div>
        </>
    );
};

export default Question;
